import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import {
  getIconicStories,
  getIconicStoriesSliceFilterId,
  isIconicStoriesReadyOrError,
  getIconicStoriesCopyHidden,
  getIconicStoriesGridSize,
} from '../../selectors';
import Tile, { tileShape } from './Tile';
import styleTiles, { tileStyle } from '../../styles/tiles';
import SideScroller from '../Scrollers/SideScroller';

const Tiles = ({
  classes,
  className,
  filterId,
  tiles,
  ready,
  hideCopy,
  gridSize,
}) => (
  <SideScroller
    key={filterId}
    className={cn(className, classes.tiles)}
    ready={ready}
    slideClassName={gridSize === 6 ? classes.sixColumnTile : classes.tile}
  >
    {tiles.map((tile, i) => (
      <Tile
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        className={gridSize === 6 ? classes.sixColumnTile : classes.tile}
        {...tile}
        hideCopy={hideCopy}
      />
    ))}
  </SideScroller>
);

Tiles.propTypes = {
  filterId: PropTypes.number,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  tiles: PropTypes.arrayOf(PropTypes.shape(tileShape)).isRequired,
  ready: PropTypes.bool.isRequired,
  hideCopy: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  gridSize: PropTypes.number,
};

Tiles.defaultProps = {
  filterId: undefined,
  className: undefined,
  hideCopy: false,
  gridSize: 4,
};

const mapStateToProps = (state, { sliceId }) => ({
  filterId: getIconicStoriesSliceFilterId(state, sliceId),
  tiles: getIconicStories(state, sliceId),
  ready: isIconicStoriesReadyOrError(state, sliceId),
  hideCopy: getIconicStoriesCopyHidden(state, sliceId),
  gridSize: getIconicStoriesGridSize(state, sliceId),
});

export default compose(
  connect(mapStateToProps),

  injectSheet({
    ...styleTiles('tile', 'tiles', 4),
    sixColumnTile: tileStyle(6),
  }),
)(Tiles);
